'use client';

import { twMerge } from '@sortlist-frontend/design-system';

import { useBriefingLink } from '_components/Briefing/hooks/useBriefingLink';

interface Props {
  label: string;
  expertiseId?: number;
  className?: string;
}

export const BriefingCta = (props: Props) => {
  const { label, expertiseId, className } = props;
  const briefingLink = useBriefingLink({ cta: 'footer', expertiseId });

  return (
    <a
      {...briefingLink}
      aria-label={label}
      data-testid="briefing-footer-btn"
      className={twMerge(
        'inline-block m-0 border-none bg-transparent p-0 text-secondary-700 outline-none text-sm',
        className,
      )}>
      {label}
    </a>
  );
};
